import { Dispatch } from 'redux';
import { AdminApi } from '../../../api/api.apiclient';
import { STORE_NEW_TOKEN } from '../../authentication/types/authentication.types';
import { GET_CLASSIFIER_TYPES_LIST } from '../types/classifiertypes.types';


export const getClassifierTypeList = () => async (dispatch: Dispatch<any>): Promise<any> => {
  const response = await AdminApi.ClassifierTypes.listAllClassifierTypes();

  dispatch({
    type: STORE_NEW_TOKEN,
    payload: {
      token: response.accessToken
    }
  });

  dispatch({
    type: GET_CLASSIFIER_TYPES_LIST,
    payload: { page: response.data }
  });

  return Promise.resolve();
};
